const STORAGE_KEY = 'albfinans_popup_seen';

function isVideo(src) {
  return /youtube\.com|youtu\.be|vimeo\.com|\.mp4|\.webm|\.ogg/i.test(src || '');
}

function toEmbed(src) {
  if (/youtube\.com|youtu\.be/.test(src)) {
    const id = src.match(/(?:v=|youtu\.be\/|embed\/)([a-zA-Z0-9_-]{11})/)?.[1];
    return id ? `https://www.youtube.com/embed/${id}?rel=0` : src;
  }
  if (/vimeo\.com/.test(src)) {
    const id = src.match(/vimeo\.com\/(?:video\/)?(\d+)/)?.[1];
    return id ? `https://player.vimeo.com/video/${id}` : src;
  }
  return src;
}

window.initPopup = function (desktopSrc, mobileSrc, popupLink) {
  try { if (sessionStorage.getItem(STORAGE_KEY)) return; } catch (e) {}

  const isMobile     = window.innerWidth <= 680;
  const activeSrc    = (isMobile && mobileSrc) ? mobileSrc : desktopSrc;
  const activeVideo  = isVideo(activeSrc);

  let content = '';
  if (activeVideo) {
    if (/youtube\.com|youtu\.be|vimeo\.com/.test(activeSrc)) {
      content = `<div class="popup-video-wrapper">
        <iframe src="${toEmbed(activeSrc)}" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>`;
    } else {
      content = `<div class="popup-video-wrapper">
        <video src="${activeSrc}" controls playsinline preload="metadata"></video>
      </div>`;
    }
  } else {
    content = `<img class="popup-image" src="${activeSrc}" alt="" loading="eager">`;
  }

  const wrappedContent = popupLink
    ? `<a class="popup-link" href="${popupLink}" target="_blank" rel="noopener noreferrer">${content}</a>`
    : content;

  document.body.insertAdjacentHTML('beforeend', `
    <div class="popup-overlay" id="popupOverlay" role="dialog" aria-hidden="true">
      <div class="popup-modal${activeVideo ? '' : ' popup-modal--image'}">
        <button class="popup-close" id="popupClose" type="button" aria-label="Kapat">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <div class="popup-body">${wrappedContent}</div>
      </div>
    </div>`);

  const overlay = document.getElementById('popupOverlay');

  function close() {
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    overlay.querySelectorAll('iframe').forEach(fr => { const s = fr.src; fr.src = ''; fr.src = s; });
    overlay.querySelectorAll('video').forEach(v => { v.pause(); v.currentTime = 0; });
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  setTimeout(() => {
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }, 800);

  document.getElementById('popupClose').addEventListener('click', close);
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('is-active')) close();
  });
};

export default {
  init() {
    if (window._popupArgs) {
      window.initPopup(...window._popupArgs);
      delete window._popupArgs;
    }
  },
};
